import {
  ProfileHttpStore,
  ProfileProjectionStore,
} from './store'

export * from './store'
export * from './publicProfile'
export const profileStore = ProfileProjectionStore.new()
export const profileHttpStore = ProfileHttpStore.new()
